export enum ProfileStrength {
  LOW = "low",
  MODERATE = "moderate",
  STRONG = "strong",
}

export interface MemberStats {
  docsCount: number;
  remindersCount: number;
  memoriesCount: number;
  emergencyCardReady: boolean;
  emergencyCardComplete: boolean;
  healthSummaryReady: boolean;
  labInsightsReady: boolean;
  healthProfileComplete: boolean;
  insuranceAdded: boolean;
  vitalsAdded: boolean;
  /** Whether this member has at least one active medication/pillbox entry (computed live, not stored). */
  medicationsAdded?: boolean;
  profileScore: number;
  profileStrength: ProfileStrength;
}

export interface FamilyStats {
  familyId: string;
  totalDocs: number;
  totalReminders: number;
  totalHealthMemories: number;
  totalEmergencyCardReady: number;
  totalHealthSummaryReady: number;
  totalHealthProfileCompleted: number;
  totalVitalsAdded: number;
  totalLabInsightsReady: number;
  totalMedicationsAdded: number;
  memberStats: { [memberId: string]: MemberStats };
}

export interface UpdateMemberStatsDto {
  memberId: string;
  docsCount?: number;
  remindersCount?: number;
  memoriesCount?: number;
  emergencyCardReady?: boolean;
  healthSummaryReady?: boolean;
  labInsightsReady?: boolean;
  healthProfileComplete?: boolean;
  insuranceAdded?: boolean;
  vitalsAdded?: boolean;
  profileScore?: number;
  profileStrength?: ProfileStrength;
}
